///include /assets/js/plugins/dacController.js
///include /assets/js/app/s/catalogue.js

// dac(v-bind:domain-store="SDomainStore.inst")

/** @type {?string} */
var appPrefix
class SDomainStore extends NetworkPropertySet {
    constructor() {
        super()
        this.catalogue = UserCatalogue.inst
        this.baseDomainCategory = domain_categories(this.catalogue.currency)
        UserCatalogue.inst.preload(["config", "products", "userVATRate"])

        /**
         * @type {?{id: string, name: string, oid: string, pendingTransfer: boolean}[]}
         */
        this.domains = null

        /**
         * @type {?{ [key: string]: string[] }}
         */
        this.domainCategory = null

        /**
         * @type {?number}
         */
        this.exchangeRate = null
        /** @type {?{[tld: string]: SBDomainProduct}} */
        this.productByTld = null
        /** @type {?{[tld: string]: SBDomainProduct}} */
        this.transferProductByTld = null
        /**
         * @type {?{isReseller: boolean}}
         */
        this.userInfoGeneral = null
        /**
         * @type {?{[tld: string]: number[]}}
         */
        this.yearsByTld = null
    }
    static get inst() {
        if(!this._inst) {
            this._inst = new SDomainStore()
        }
        return this._inst
    }
    get domainsRegistered() {
        if(!appPrefix || location.href.startsWith(appPrefix)) {
            if(this.domains) {
                return this.domains.filter(
                    datum => !datum.pendingTransfer
                ).map(datum => datum.name)
            } else {
                return []
            }
        } else {
            return []
        }
    }
    get networkPropertyHandlers() {
        return {
            /** @optional /o/domain */
            domains: f => $.ajax({
                method: "get",
                url: `${appPrefix}/o/domain`,
                xhrFields: {
                    withCredentials: true
                },
            }).done(f),
            domainCategory: async () => {
                const res = await $.ajax({
                    method: "get",
                    url: `${appPrefix}/a/domainCategory`,
                    xhrFields: {
                        withCredentials: true
                    },
                })

                if (!res || !res.length) return this.baseDomainCategory

                const result = res.reduce((categories, val) => {
                    categories[val.CategoryName] = val.Content.length ? val.Content.split(',') : []
                    return categories
                }, {})

                return { ...this.baseDomainCategory, ...result }
            },
            domainDiscountCodes: async () => $.ajax({
                method: "get",
                url: `${appPrefix}/a/catalogue/domainDiscountCodes`,
                xhrFields: {
                    withCredentials: true
                },
            }),
            exchangeRate: () => this.catalogue.preloadSingle("currencyRate"),
            productByTld: async () => {
                const products = await this.catalogue.preloadSingle("products")
                /** @type {{[tld: string]: SBDomainProduct}} */
                const out = {}
                for(const product of products) {
                    if(product instanceof SBDomainProduct) {
                        // product.prices (action=null)
                        out[product.tld] = product //
                    }
                }
                return out
            },
            transferProductByTld: async () => {
                const products = await this.catalogue.preloadSingle("products")
                /** @type {{[tld: string]: SBDomainProduct}} */
                const out = {}
                for(const product of products) {
                    if(product instanceof SBDomainProduct) {
                        // product.prices (action=transfer)
                        out[product.tld] = product //
                    }
                }
                return out
            },
            userInfoGeneral: f => $.ajax({
                method: "get",
                url: `${appPrefix}/a/userInfoGeneral`,
                dataType: "json",
                xhrFields: {
                    withCredentials: true
                },
            }).done(f),
            yearsByTld: () => $.ajax(`${appPrefix}/a/domain-period`),
        }
    }
    /**
     * @param {string} name
     * @returns {Promise<boolean>}
     */
    async undelete(name) {
        throw new Error("Not implemented")
    }
}
AnyDomainStore.register(SDomainStore)
